export class MeetingItem {
    id: string = '';
    name: string = '';
    key: string = '';
    moderatorKey: string = '';
    archived: boolean = false;
}
